export default "<div class=\"loading\"></div>\n";